import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import NLink from '@src/components/NLink';

import css from './style.module.scss';
import Icon from './assets/Icon';

const Advert = (props) => {
	const { pre, title, text, linkLabel, onClick } = props;
	return (
		<div className={cn(css.block)}>
			<div className={css.iconBlock}>
				<Icon className={css.icon} />
			</div>
			<div className={css.content}>
				<div className={css.title}>
					{pre && <div className={css.pre}>{pre}&nbsp;</div>}
					{title}
				</div>
				<div className={css.text}>{text}</div>
			</div>
			<div className={css.btns}>
				<NLink>
					<a
						tabIndex={0}
						role="link"
						onClick={onClick}
						className={css.btn}
					>
						{linkLabel}
					</a>
				</NLink>
			</div>
		</div>
	);
};

Advert.propTypes = {
	pre: PropTypes.string,
	title: PropTypes.string,
	text: PropTypes.string,
	linkLabel: PropTypes.string,
	onClick: PropTypes.func,
};

Advert.defaultProps = {
	pre: undefined,
	title: undefined,
	text: undefined,
	linkLabel: undefined,
	onClick: undefined,
};

export default Advert;
